import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import type { Routes } from "@angular/router";

export const routes: Routes = [
    {
        path: "",
        redirectTo: "login",
        pathMatch: "full"
    },
    {
        path: "dashboard",
        loadComponent: async () => import("./features/dashboard/dashboard.component").then((m) => m.DashboardComponent),
        loadChildren: async () => import("./features/dashboard/dashboard.routes"),
        canActivate: [AuthGuard],
        data: { authGuardPipe: () => redirectUnauthorizedTo(["login"]) }
    },
    {
        path: "forgot-password",
        loadComponent: async () =>
            import("./features/forgot-password/forgot-password.component").then((m) => m.ForgotPasswordComponent),
        canActivate: [AuthGuard],
        data: { authGuardPipe: () => redirectLoggedInTo(["dashboard"]) }
    },
    {
        path: "login",
        loadComponent: async () => import("./features/login/login.component").then((m) => m.LoginComponent),
        canActivate: [AuthGuard],
        data: { authGuardPipe: () => redirectLoggedInTo(["dashboard"]) }
    },
    {
        path: "reset-password/:uuid",
        loadComponent: async () =>
            import("./features/reset-password/reset-password.component").then((m) => m.ResetPasswordComponent)
    },
    {
        path: "design",
        loadComponent: async () =>
            import("./features/design-page/design-page.component").then((m) => m.DesignPageComponent)
    }
];
